<template>
  <article>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="date" label="日期" width="" align="center">
      </el-table-column>
      <el-table-column prop="new_count" label="新增用户" width="" align="center">
      </el-table-column>
      <el-table-column prop="user_upload_count" label="报单用户数" width="" align="center">
      </el-table-column>
      <el-table-column prop="task_upload_count" label="报单广告数" width="" align="center">
      </el-table-column>
      <el-table-column prop="upload_ocount" label="报单订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="upload_payment" label="报单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="upload_commission" label="报单佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_ocount" label="丢单订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_payment" label="丢单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_ocount" label="可提现订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_commission" label="可提现金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_commission" label="打款金额" width="" align="center">
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {earnBase} from '../../../api/api'
export default {
  name: 'earnBase',
  mixins: [mixinList],
  data () {
    return {
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      this.listLoading = true
      earnBase(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnBase.vue